var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { "data-id": _vm.object.label || _vm.field } }, [
    _vm.object.multiple
      ? _c(
          "div",
          [
            _c("multiselect", {
              staticStyle: { position: "relative", "z-index": "200" },
              attrs: { multiple: true, options: _vm.optionsList },
              model: {
                value: _vm.mutatedObject[_vm.field],
                callback: function ($$v) {
                  _vm.$set(_vm.mutatedObject, _vm.field, $$v)
                },
                expression: "mutatedObject[field]",
              },
            }),
          ],
          1
        )
      : _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.mutatedObject[_vm.field],
                expression: "mutatedObject[field]",
              },
            ],
            staticClass: "form-control",
            attrs: { required: _vm.object.required },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.mutatedObject,
                  _vm.field,
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          [
            _c("option", { attrs: { selected: "", disabled: "", value: "" } }, [
              _vm._v(
                "Select " +
                  _vm._s(_vm._f("capitalize")(_vm.object.label || _vm.field))
              ),
            ]),
            _vm._l(_vm.optionsList, function (item) {
              return _c(
                "option",
                { domProps: { value: item[_vm.object.value] || item } },
                [
                  _vm.object.displayedFields
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.object.displayedFields,
                          function (displayedField) {
                            return _c("span", [
                              _vm._v(_vm._s(item[displayedField] + " ")),
                            ])
                          }
                        ),
                        0
                      )
                    : _c("span", [_vm._v(_vm._s(item))]),
                ]
              )
            }),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }